<script lang="ts">
  import { Alert } from "sveltestrap";
  import { AlertswithLinks, AlertswithLinksMessage, Alertswithicons, AlertswithiconsMessage, BasicAlert, BasicAlertMessage, DismissibleAlerts, DismissibleAlertsMessage, href } from "../../../../utils/Constant/Constant";
  import Link from "svelte-link";
</script>
<tr>
    <td>{BasicAlert}</td>
    <td class="w-50">
      <Alert color="primary">
        <p class="font-light">
          <strong>Success!</strong> Indicates a successful or positive action.
        </p>
      </Alert>
    </td>
    <td>
      <p><span>{@html BasicAlertMessage}</span></p>
    </td>
  </tr>
  <tr>
    <td>{AlertswithLinks}</td>
    <td>
      <Alert color="primary">
        <p class="font-light">
          <strong>Success!</strong> You should <Link class="alert-link" href={href}>read this message</Link>.
        </p>
      </Alert>
    </td>
    <td>
      <p><span>{@html AlertswithLinksMessage}</span></p>
    </td>
  </tr>
  <tr>
    <td>{DismissibleAlerts}</td>
    <td>
      <Alert color="secondary" dismissible class="fade show" >
        <p class="font-light">
          <strong>Holy !</strong> You can check in on some of those fields below.
        </p>
      </Alert>
    </td>
    <td><span>{@html DismissibleAlertsMessage}</span></td>
  </tr>
  <tr>
    <td>{Alertswithicons}</td>
    <td>
      <Alert color="primary" dismissible class="inverse fade show">
        <i class="icofont icofont-heart-alt"></i>
        <p>Good Morning! Start your day with some alerts.</p>
      </Alert>
    </td>
    <td><span>{@html AlertswithiconsMessage}</span></td>
  </tr>